import { useEffect, useState } from 'react';
import { Table, TableHeader, Text } from '@recargas-dominicanas/core/components';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { BankAccountStore } from '../../../store/bankAccountStore';
import { OptionButton } from '@recargas-dominicanas/core/components';
import { EditModal } from './editModal/edit-modal.component';
import { ConfigRow } from './config-row/config-row.component';
import { style } from './config.module.css';

interface Props {
  id: number;
}

export function Config(props: Props) {

  const configs = BankAccountStore.getConfigs(props.id);
  const [openEditModal, setOpenEditModal] = useState(false);

  useEffect(() => {
    BankAccountStore.fetchConfigs(props.id);
  }, [props.id]);

  async function handleAddConfig(key: string, value: string) {
    await BankAccountApi.addConfig(props.id, key, value);
    BankAccountStore.fetchConfigs(props.id);
  }

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <Text text='Nombre'/>
          <Text text='Valor'/>
          <div>
            <OptionButton 
              className={style.addOption} 
              icon='library_add' 
              title='Agregar'
              onClick={() => setOpenEditModal(true)}/>
          </div>
        </TableHeader>
        <tbody>
          {
            configs?.map(config => 
              <ConfigRow
                key={config.id}
                bankAccountId={props.id}
                config={config}/>
            )
          }
        </tbody>
      </Table>
      <EditModal
        title='Agregar configuración'
        errorMessage='Error agregando configuración'
        open={openEditModal}
        onSave={handleAddConfig}
        onClose={() => setOpenEditModal(false)}/>
    </div>
  );
}
